export enum ServiceType {
    UNKNOWN,
    CALENDARBASED,
    GROUP,
    MULTISESSIONCOURSE,
    BASICCOURSE,
    HOLIDAY
}